import React from 'react';
import { Form, Upload, Button } from 'antd';
import { AddItemFormData } from './types';

const { Dragger } = Upload;

interface UploadFilesProps {
  styles: { [key: string]: string };
  formData: AddItemFormData;
  setFormData: React.Dispatch<React.SetStateAction<AddItemFormData>>;
  uploadProps: any;
}

const UploadFiles: React.FC<UploadFilesProps> = ({ styles, formData, setFormData, uploadProps }) => (
  <div className={styles.stepContainer}>
    <h2 className={styles.stepTitle}>Upload Files</h2>
    
    <div className={styles.uploadMainGrid}>
      <div className={styles.topUploadsRow}>
        <div className={styles.uploadSection}>
          <Form.Item label="Thumbnail" className={styles.formItem}>
            <p className={styles.uploadDescription}>
              Upload a thumbnail image for your item. Supported file types: JPG, PNG, Max Size 5MB
            </p>
            <Dragger {...uploadProps} className={styles.uploadArea}>
              <div className={styles.uploadContent}>
                <p className={styles.uploadText}>Drag and drop Your Files here, or</p>
                <Button type="link" className={styles.browseButton}>Browse Files</Button>
              </div>
            </Dragger>
            
            {formData.thumbnail && formData.thumbnail.length > 0 && (
              <div className={styles.uploadedFiles}>
                <h4>Uploaded File:</h4>
                {formData.thumbnail.map((file: any, index: number) => (
                  <div key={index} className={styles.uploadedFile}>
                    <div className={styles.filePreview}>
                      {file.type?.startsWith('image/') ? (
                        <img 
                          src={URL.createObjectURL(file)} 
                          alt={file.name}
                          className={styles.previewImage}
                        />
                      ) : (
                        <div className={styles.fileIcon}>📄</div>
                      )}
                    </div>
                    <div className={styles.fileInfo}>
                      <p className={styles.fileName}>{file.name}</p>
                      <p className={styles.fileSize}>
                        {(file.size / 1024 / 1024).toFixed(2)} MB
                      </p>
                    </div>
                    <button
                      type="button"
                      className={styles.removeBtn}
                      onClick={() => {
                        setFormData(prev => ({
                          ...prev,
                          thumbnail: []
                        }));
                      }}
                    >
                      ✕
                    </button>
                  </div>
                ))}
              </div>
            )}
          </Form.Item>
        </div>
      </div>
    </div>
  </div>
);

export default UploadFiles;
